import type { IconName } from '#/components/Icon/IconName';
import type { I18nFn } from '#/i18n/types/I18nFn';
import type { I18nLocale } from '#/i18n/types/I18nLocale';

import type { PageFooterLinkType } from './types/PageFooterData';

export function pageFooterSocialLinks(i18n: I18nFn): Record<
  I18nLocale,
  {
    href: string;
    eventName: string;
    iconName: IconName;
  }[]
> {
  return {
    es: [
      {
        href: i18n(
          'https://www.linkedin.com/company/idealist-espanol-impacto-social',
        ),
        eventName: 'Follow Idealist',
        iconName: 'social/linkedin',
      },
      {
        href: i18n('https://www.instagram.com/idealistas_org/'),
        eventName: 'Follow Idealist',
        iconName: 'social/instagram',
      },
      {
        href: i18n('https://www.facebook.com/Idealistasorg'),
        eventName: 'Follow Idealist',
        iconName: 'social/facebook',
      },
      {
        href: i18n('https://twitter.com/idealistas_org'),
        eventName: 'Follow Idealist',
        iconName: 'social/x',
      },
    ],
    en: [
      {
        href: i18n('https://www.tiktok.com/@joinidealist'),
        eventName: 'Follow Idealist',
        iconName: 'social/tiktok',
      },
      {
        href: i18n('https://www.linkedin.com/company/idealist.org'),
        eventName: 'Follow Idealist',
        iconName: 'social/linkedin',
      },
      {
        href: i18n('https://instagram.com/joinidealist'),
        eventName: 'Follow Idealist',
        iconName: 'social/instagram',
      },
      {
        href: i18n('https://www.facebook.com/Idealist'),
        eventName: 'Follow Idealist',
        iconName: 'social/facebook',
      },
    ],
    pt: [
      {
        href: i18n('https://www.linkedin.com/company/plataformaidealist'),
        eventName: 'Follow Idealist',
        iconName: 'social/linkedin',
      },
      {
        href: i18n('https://www.instagram.com/idealist.br'),
        eventName: 'Follow Idealist',
        iconName: 'social/instagram',
      },
      {
        href: i18n('https://www.facebook.com/idealist.pt'),
        eventName: 'Follow Idealist',
        iconName: 'social/facebook',
      },
      {
        href: i18n('https://www.youtube.com/@Idealismo_pt'),
        eventName: 'Follow Idealist',
        iconName: 'social/youtube',
      },
      {
        href: i18n('https://chat.whatsapp.com/JTonbYBt5mAAw8qmQPLJFq'),
        eventName: 'Follow Idealist',
        iconName: 'social/whatsapp',
      },
    ],
  };
}

export const pageFooterDataByLinkType: Record<
  PageFooterLinkType,
  { trackClickedName: string }
> = {
  // Idealist Days
  'our-vision': { trackClickedName: 'Our vision' },
  'spread-the-word': { trackClickedName: 'Spread the word' },
  'plan-ahead': { trackClickedName: 'Plan ahead' },
  'take-a-logo': { trackClickedName: 'Take a logo' },
  'support-our-work': { trackClickedName: 'Support our work' },

  // Find a Job
  jobs: { trackClickedName: 'Jobs' },
  internships: { trackClickedName: 'Internships' },
  organizations: { trackClickedName: 'Organizations' },
  'salary-explorer': { trackClickedName: 'Salary Explorer' },
  'career-advice': { trackClickedName: 'Career Advice' },

  // Post on Idealist
  'post-a-listing': { trackClickedName: 'Post a Listing' },
  'create-org': { trackClickedName: 'Create Org' },
  'create-community-group': { trackClickedName: 'Create Community Group' },
  'employer-resources': { trackClickedName: 'Employer Resources' },
  'for-grad-schools': { trackClickedName: 'For Grad Schools' },
  recruitment: { trackClickedName: 'Recruitment' },

  // About Us
  'our-story': { trackClickedName: 'Our Story' },
  'our-mission': { trackClickedName: 'Our Mission' },
  'our-team': { trackClickedName: 'Our Team' },
  'data-insights': { trackClickedName: 'Data & Insights' },
  'our-partners': { trackClickedName: 'Our Partners' },
  donate: { trackClickedName: 'Donate to Idealist' },

  // Learn More
  'help-center': { trackClickedName: 'Help Center' },
  'contact-us': { trackClickedName: 'Contact Us' },
  'terms-of-service': { trackClickedName: 'Terms Of Service' },
  'privacy-policy': { trackClickedName: 'Privacy Policy' },
  'site-map': { trackClickedName: 'Site Map' },
};
